import { Box, Button, Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import KanseiBreadcrumbs from 'components/breadcrumb'
import KanseiSimpleSelectBox from 'components/simpleSelectBox'
import KanseiTextField from 'components/textField'
import { groupApi } from 'hooks/api/group'
import { Option } from 'types/option'

interface Form {
  name: string
  parentId?: string
}

export default function CreatePage() {
  const [options, setOptions] = useState<Option[]>([])
  const [selectAction, setSelectAction] = useState<string>()
  const navigate = useNavigate()
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Form>()

  const onSubmit = (form: Form) => {
    if (confirm('作成しますか？')) {
      const parentId = options.find((x) => x.value === selectAction)?.value

      const data = {
        name: form.name,
        parentId: parentId ? String(parentId) : undefined,
      }

      groupApi()
        .add(data)
        .then(() => {
          navigate('/group')
        })
        .catch((error) => {
          console.error('Error creating group:', error)
          alert('グループの作成に失敗しました。')
        })
    }
  }

  const handleSelectAction = (value: string) => {
    setSelectAction(value)
  }

  useEffect(() => {
    groupApi()
      .getAll()
      .then((res) => {
        const options: Option[] = res.data.map((group) => ({
          label: group.name,
          value: group.id,
        }))
        setOptions(options)
      })
      .catch((error) => {
        console.error('Error fetching groups:', error)
        alert('グループの取得に失敗しました。')
      })
  }, [])

  const links = [
    {
      title: 'グループ管理一覧',
      to: '/group',
    },
    {
      title: 'グループ管理新規作成',
    },
  ]

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{ '& .MuiTextField-root': { m: 1 }, maxWidth: '500px' }}
    >
      <KanseiBreadcrumbs links={links} style={{ marginBottom: '15px' }} />
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <KanseiTextField
            id="name"
            label="グループ管理名"
            control={control}
            errors={errors}
            required
          />
        </Grid>
        <Grid item xs={4}>
          <KanseiSimpleSelectBox
            style={{ width: '250px', margin: '8px' }}
            options={options}
            value={selectAction}
            onChange={handleSelectAction}
          ></KanseiSimpleSelectBox>
        </Grid>
      </Grid>
      <Button type="submit" variant="contained" sx={{ mt: 2 }}>
        作成
      </Button>
    </Box>
  )
}
